import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/Nobagday/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/Nobagday/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/Nobagday/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/Nobagday/4.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';


const TeachersDatClass6to12 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
const p1 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/1.webp`;
const p2 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/2.webp`;
const p3 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/3.webp`;
const p4 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/4.webp`;
const p5 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/5.webp`;
const p6 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/6.webp`;
const p7 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/7.webp`;
const p8 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/8.webp`;
const p9 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/9.webp`;
const p10 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/10.webp`;
const p11 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/11.webp`;
const p12 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/12.webp`;
const p13 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/13.webp`;
const p14 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/14.webp`;
const p15 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/15.webp`;
const p16 = `${config.base_image_url}/home/events-activities/school-programs/TeachersDayClass6to12/16.webp`;

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
          },
          {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
          },
          {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
          },
          {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
          },
          {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
          },
          {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
          },
          {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
          },
          {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
          },
          {
            src: p9,
            source: p9,
            rows: 1.3,
            cols: 1,
          },
          {
            src: p10,
            source: p10,
            rows: 1.3,
            cols: 1,
          },
          {
            src: p11,
            source: p11,
            rows: 1,
            cols: 1,
          },
          {
            src: p12,
            source: p12,
            rows: 1,
            cols: 1,
          },
          {
            src: p13,
            source: p13,
            rows: 1,
            cols: 1,
          },
          {
            src: p14,
            source: p14,
            rows: 1,
            cols: 1,
          },
          {
            src: p15,
            source: p15,
            rows: 1,
            cols: 1,
          },
          {
            src: p16,
            source: p16,
            rows: 1,
            cols: 1,
          }
         
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                TEACHERS DAY
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Class: 6-12 Date: : 5 September 2024
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “With pure hearts and beaming smiles, our young learners gathered to celebrate the guiding stars in their lives—their cherished teachers.””

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Teachers' Day was celebrated on 5 September, 2024 by the students of National Public School Yeshwanthpur to express their gratitude to their teachers. The student council led the way by organising a cultural tribute and ensured that their sincere gratitude touched a chord with every teacher.
                                    <br></br>
                                    The celebration commenced with enumerating the significance and honouring Dr Sarvepalli Radhakrishnan, our first president of independent India, whose birth anniversary is marked as ‘Teacher’s Day’. This was followed by a series of cultural performances which included mesmerising dances, melodious rendition of songs and a humorous skit. The theme of the skit was particularly noteworthy as it emphasised the role of teachers in our lives even in this technology driven world. It particularly drew a lot of laughter from the audience, as it reflected both the challenges and joys of the student-teacher relationship. It was reassuring to witness students of all age groups, collaborated to thank their mentors.
                                    <br></br>
                                    Our respected Principal Ma’am acknowledged the students’ heartfelt efforts in making the day truly special for all educators, reflecting their deep love and appreciation. A poignant line from her speech resonated with everyone- ‘the very existence of teachers is made meaningful by the presence of their cherished students.’ The wide smiles, lively chatter and a warm atmosphere, stands testament to the profound connection between teachers and students that fosters growth, inspiration and a vibrant school community.  
                                    <br></br>
                                    

                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Teachers affect eternity; they can never tell where their influence stops."
                                <br />
                                
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2024/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default TeachersDatClass6to12;